function isAverageExperienceSelector (selectorName) {
  return String(selectorName || '').toLowerCase().includes('average experience')
}

function formatKpiPeriodMonth (value) {
  if (!value) return null
  const date = value instanceof Date ? value : new Date(value)
  if (isNaN(date.getTime())) return null
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  return `${year}-${month}`
}

function monthsOnProject (firstReportDate, periodEnd) {
  const start = new Date(firstReportDate)
  const end = new Date(periodEnd)
  if (isNaN(start.getTime()) || isNaN(end.getTime())) return 0
  return (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth()) + 1
}

function totalMonthsOnProject (tenures) {
  return tenures.reduce((total, months) => total + months, 0)
}

function averageExperience (tenures) {
  if (!tenures.length) return 0
  return Math.round((totalMonthsOnProject(tenures) / tenures.length) * 100) / 100
}

module.exports = {
  isAverageExperienceSelector,
  formatKpiPeriodMonth,
  monthsOnProject,
  totalMonthsOnProject,
  averageExperience
}
